<template>
  <div class="flex flex-row h-screen flex-wrap">
      <TopBar/>
      <LeftBar/>
      <Container class="relative"/>
  </div>
</template>

<script>
import LeftBar from '@/components/dashboard/LeftBar'
import TopBar from '@/components/dashboard/TopBar'
import Container from '@/components/dashboard/Container.vue'
export default {
    name : "Dashboard",
    components:{
        LeftBar,
        TopBar,
        Container
    }
}
</script>

<style>

</style>